import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Signal,
  ViewChild,
  effect,
  inject,
  input,
} from '@angular/core';
import Chart, { ChartConfiguration, ChartConfigurationCustomTypesPerDataset } from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { getMinMaxDate } from '../../services/assessmentsHistory.functions';
import { AssessmentChartDataRow, AssessmentChartDataSets, SubTestChartDataSet } from '../../services/model';
import { highlightPlugin, splitTextByMaxChars } from '../chart-utils/utils.functions';

@Component({
  selector: 'app-line-chart-single',
  standalone: true,
  imports: [],
  templateUrl: './line-chart-single.component.html',
  styleUrl: './line-chart-single.component.scss',
})
export class LineChartSingleComponent implements OnInit {
  @Input() data!: Array<AssessmentChartDataRow> | undefined;
  @Input() dataFull!: Signal<AssessmentChartDataSets | undefined>;
  @Input() chartId!: string;
  @Input() label!: string;
  selectedIndex = input(0);
  @Output() indexClicked = new EventEmitter<number>(true);
  @ViewChild('canvas', { read: ElementRef, static: true }) canvas!: ElementRef<any>;
  public chart: any;
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    dayjs.locale('de');

    // getPersistedConfig()

    effect(() => {
      this.dataFull();
      if (this.chart) {
        this.createChart();
        this.cdr.detectChanges();
        setTimeout(() => {
          // P.S. WTF!!!
          this.createChart();
          this.cdr.detectChanges();
        }, 50);
      }
    });
    effect(() => {
      const newIndex = this.selectedIndex();
      // console.log('chriss effect' + newIndex);
      this.updateChart(newIndex);
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.createChart();
      this.cdr.detectChanges();
    }, 50);
  }

  // Aktualisiere den Chart, wenn der Highlight-Index geändert wird
  updateChart(selectedIndex: number) {
    if (this.chart) {
      // console.log('chriss ' + selectedIndex);

      this.chart.options.plugins!.highlightPlugin!.highlightIndex = selectedIndex;
      this.chart.update();
    }
  }

  createChart() {
    // jür jedes Datum eine Row
    const datasetsObject: AssessmentChartDataSets = this.dataFull() ?? {};
    const { minDate, maxDate, labelDataFull } = getMinMaxDate(datasetsObject);

    // data Array enthält für jeden Behandlungstermin eine Element, also eine Row
    // da steht dann immer der im Drop-Down selektierte subType score drin, je links und rechts
    const dataRows: Array<AssessmentChartDataRow> = this.data ?? [];
    // const assesmentType: AssessmentType = dataRows[0]?.type ?? 'BBS';
    // const color = assessmentTypeColors[assesmentType];
    const data = dataRows.map(row => {
      let unitLabel = '';
      if (this.chartId === 'bbs') {
        unitLabel = 'von 56 Punkten';
      }
      if (this.chartId === 'fga') {
        unitLabel = 'von 30 Punkten';
      }
      if (this.chartId === 'custom') {
        // unitLabel = '';
      }
      if (this.chartId === 'tug') {
        unitLabel = 'Sekunden';
      }

      const dataset: SubTestChartDataSet = row.subDataSets[0];

      // const score = row.score;
      // const data = dataset.score;

      let score = row.score!;
      let sum = dataset?.sum;
      const hasComment: boolean = dataset?.hasComment || row.hasComment;
      const comment: string | undefined = row.comment || dataset?.comment;
      // const data = 100 - dataset.score;
      if (this.chartId === 'custom') {
        score = row.score_left!;
        sum = row.score_left!;
      }
      // Invertierung Schädigung zu Erfüllung
      score = 100 - score;

      return {
        x: new Date(new Date(row.dateIso).toDateString()),
        data: score,
        hasComment,
        comment,
        sum: sum,
        tooltipLabel: unitLabel !== '' ? ` ${score} %  (${sum} ${unitLabel}) ` : ` ${score} % `,
        documentId: row.documentId,
        assessmentType: row.type,
      };
    });

    // im multi-Line-chart haben wir immer nur 2 Datasets: eins für links und eins für rechts.
    // die liegen aber beide bereits in data. werden über den yAxisKey rausgefischt.
    const datasets = [
      {
        label: this.label,
        data: data,
        parsing: {
          yAxisKey: 'data',
        },
        borderWidth: 2,
        tension: 0.2,
        backgroundColor: '#ddd',
        borderColor: '#999',

        pointHitRadius: 20,
        pointStyle: 'circle',
        pointRadius: 10,
        pointHoverRadius: 10,
      },
    ];

    const config = this.getChartConfig(datasets, minDate, maxDate, labelDataFull);

    if (this.chart) {
      this.chart.data = { labels: labelDataFull, datasets: datasets };
      this.chart.options.scales.x.min = minDate;
      this.chart.options.scales.x.max = maxDate;
      this.chart.update();
    } else {
      this.chart = new Chart(this.canvas.nativeElement, config);
      setTimeout(() => {
        this.canvas.nativeElement.addEventListener('click', (e: any) => {
          const points = this.chart.getElementsAtEventForMode(e, 'nearest', {}, true);
          const index = points?.length > 0 ? points[0].index : -1;
          if (index > -1) {
            this.indexClicked.emit(index);
          }
        });
      }, 250);
    }
  }

  getChartConfig(
    datasets: any,
    minDate: any,
    maxDate: any,
    labelDataFull: any
  ): ChartConfiguration | ChartConfigurationCustomTypesPerDataset {
    return {
      type: 'line',
      data: {
        labels: labelDataFull,
        datasets: datasets,
      },
      options: {
        interaction: {
          intersect: false,
          axis: 'xy',
          mode: 'index',
        },
        responsive: true,
        aspectRatio: 3,
        animation: {
          delay: 100,
        },
        clip: false,
        layout: {
          // autoPadding: true,
          //   padding: {
          //     left: -10,
          //     right: 10,
          //   },
        },
        scales: {
          // Erfüllung beste oben
          y: {
            min: 0,
            max: 100,

            reverse: false,
            position: 'right',
            beginAtZero: true,
            grid: {
              display: true,
            },
            ticks: {
              stepSize: 25,
              callback: function (val, index) {
                return val + ' %';
              },
            },
          },
          x: {
            offset: true,
            grid: {
              display: true,
            },
            ticks: {
              source: 'data',
              // minRotation: 20,
              autoSkip: true, // Alle Datumswerte anzeigen
              callback: function (value, index, ticks) {
                // console.log('ticks:', { value, index, ticks });
                const tickDate = dayjs(new Date(value));
                // return tickDate.format('dd, DD.MM');
                const tick = [tickDate.format('DD.MM'), tickDate.format('dd')];
                const reverseIndex = datasets[0].data!.length - 1 - index;
                if (datasets[0].data[reverseIndex].hasComment) {
                  // tick.push(`\u00A9`);
                  tick.push(`💬`);
                }
                return tick;
              },
            },
            type: 'time',
            min: minDate,
            max: maxDate,
            time: {
              unit: 'day',
              isoWeekday: true,
              displayFormats: {
                week: 'dd, DD.MM',
              },
              tooltipFormat: 'dd, DD.MM.YYYY',
            },
          },
        },
        plugins: {
          title: {
            display: false,
          },
          tooltip: {
            mode: 'index',
            bodyFont: {
              family: 'monospace',
              size: 12,
            },
            footerFont: {
              family: 'monospace',
              weight: 'normal',
              size: 12,
            },
            callbacks: {
              label: function (context) {
                const raw = context.raw as any;
                const yAxisKey = (context.dataset.parsing as any).yAxisKey;
                if (yAxisKey === 'dataL') {
                  return raw.tooltipLabelL;
                } else if (yAxisKey === 'dataR') {
                  return raw.tooltipLabelR;
                } else {
                  return raw.tooltipLabel;
                }
              },
              beforeFooter: function (context) {
                // console.log('context footer', context);
                const raw = context[0].raw as any;
                const tooltip: string[] = [];
                if (raw.hasComment) {
                  tooltip.push('');
                  tooltip.push('💬 Kommentar zum Testergebnis');
                }

                return tooltip;
              },
              footer: function (context) {
                const raw = context[0].raw as any;
                if (raw.hasComment) {
                  return splitTextByMaxChars(raw.comment, 30);
                } else {
                  return [];
                }
              },
            },
          },
          legend: {
            display: false,
            position: 'top',
            align: 'start',
            labels: {
              usePointStyle: true,
            },
          },
          highlightPlugin: {
            highlightIndex: this.selectedIndex(), // Nutze die Komponente-Variable
            highlightWidth: 40,
            color: 'rgba(192, 192, 192, 0.2)',
          },
        },
      },
      plugins: [highlightPlugin], // this.xScaleImage, this.chartClickXLabel // this.customLegend, this.customCanvasBackgroundColor, this.jitterEffectsPlugin
    };
  }

  // nach Schädigung (schlechteste Werte oben)
  drawChartBackground(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(0.04, 'rgba(255,255,255,1)');

    gradientBack.addColorStop(0.04, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.25, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.25, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.49, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.49, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.95, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.95, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(1, 'rgba(251,221,221,1)');
  }

  // nach Erfüllung (beste werte oben)
  drawChartBackgroundReverse(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(0.05, 'rgba(251,221,221,1)');

    gradientBack.addColorStop(0.05, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.51, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.51, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.75, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.75, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.96, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.96, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(1, 'rgba(255,255,255,1)');
  }

  customCanvasBackgroundColor = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart: any, args: any, options: any) => {
      const {
        ctx,
        chartArea: { left, right, top, bottom, width, height },
      } = chart;
      const canvas = chart.canvas;
      const chartArea = chart.chartArea;

      ctx.save();
      // Chart background
      const gradientBack = canvas.getContext('2d').createLinearGradient(right, bottom, right, top);
      this.drawChartBackgroundReverse(gradientBack);
      ctx.fillStyle = gradientBack;
      ctx.fillRect(
        chartArea.left,
        chartArea.bottom,
        chartArea.right - chartArea.left,
        chartArea.top - chartArea.bottom
      );
    },
  };
}
